import Debug from 'debug';
import * as React from 'react';
import { Entity, QueryOptions, Row } from 'gossamer-unified';
import {
  applyRecentSelection,
  ErrorBoundary,
  GCacheQuery,
  List,
  RecentSelectionsDropdown,
  SubSectionMultiProps,
} from 'gossamer-front-end';
import styles from '../data/QueryMulti.module.css';
import { SearchCriteriaBlock } from './SearchCriteriaBlock';
import { Alert, Spinner } from 'react-bootstrap';

const debug = Debug('gfe/se/Search');

interface Props<T extends Row> {
  entity: Entity<T>;
  excludeValues?: string[];
  gCacheQuery: GCacheQuery<T>;
  onRowClick?: (keyValue: string) => void;
  queryOptions?: QueryOptions;
  render?: (props: SubSectionMultiProps<T>) => React.JSX.Element;
  rowClickSetsSearchPaths?: boolean;
  setQueryOptions?: (newQueryOptions: QueryOptions) => void;
}

export const Search = <T extends Row>(props: Props<T>): React.JSX.Element => {
  const SubSection = props.render || List;
  const mainClassName = props.gCacheQuery.isFetching ? styles.FetchingOpacity : '';
  return (
    <ErrorBoundary>
      <SearchCriteriaBlock
        entity={props.entity}
        queryOptions={props.queryOptions}
        updateQueryOptions={props.setQueryOptions}
      />
      {props.onRowClick && <RecentSelectionsDropdown entity={props.entity} onRecentSelectedReused={props.onRowClick} />}
      {props.gCacheQuery.error && <Alert variant="danger">{props.gCacheQuery.error}</Alert>}
      {props.gCacheQuery.isFetching && (
        <div>
          <Spinner animation="border" size="sm" />
        </div>
      )}
      {props.gCacheQuery.data && !props.gCacheQuery.error && (
        <div className={mainClassName}>
          <SubSection
            entity={props.entity}
            queryOptions={props.queryOptions}
            rows={props.gCacheQuery.data}
            rowClickSetsSearchPaths={true}
            onRowClick={applyRecentSelection(props.entity, props.gCacheQuery.data, props.onRowClick) || undefined}
            updateQueryOptions={props.setQueryOptions}
          />
        </div>
      )}
    </ErrorBoundary>
  );
};
